import React from "react";
import styles from "../PropertySelector.module.scss";
import classnames from "classnames";
import TurnrDropdownSelect from "~/components/inputs/TurnrDropdownSelect";
import chroma from "chroma-js";
import { CustomImageNew } from "rylak-common/src/image/CustomImage.jsx";
import { getPropertyName, getPropertyTypeTitle, isPropertyEnabled, isPropertyEqualToReturningVariant, translatePropertyValue } from "../propertyCore";
import PropertyDescription from "./common/PropertyDescription";
import { getBrandProductImageObjectFit } from "~/cores/brandDataCore";

export default function DropdownPropertySelector(props) {
    const { appProps, selectedProduct, exchangeAlternatives, selectedProperties, propertyValues, selectedPropertyValue, propertyType, onSelectedPropertyValue } = props;

    const { getLocaleText } = appProps;

    function isValueDisabled(propertyValue) {
        return !isPropertyEnabled({
            exchangeAlternatives,
            propertyType,
            propertyTypeChoices: selectedProperties,
            propertyValue: propertyValue,
        });
    }

    return (
        <>
            <TurnrDropdownSelect
                dataTestId={"property-dropdown-" + propertyType}
                placeholder={getPropertyTypeTitle({ appProps, propertyType })}
                fullWidth={true}
                value={selectedPropertyValue}
                options={propertyValues.map((p) => p.value)}
                optionDisabled={isValueDisabled}
                renderOption={(propertyValue) => {
                    const text = translatePropertyValue({ ...props, propertyValue });
                    const propertyData = propertyValues?.find((p) => p?.value === propertyValue);

                    const propertyName = getPropertyName(propertyData);

                    const foundProperty = propertyValues?.find(({ value }) => value === propertyValue);
                    const hexColor = foundProperty?.hexColor;
                    const imageSrc = foundProperty?.imageSrc;
                    const disabled = isValueDisabled(propertyValue);
                    const isColorLight = hexColor && chroma(hexColor).luminance() > 0.82;
                    const isCurrentVariant = isPropertyEqualToReturningVariant(propertyData, { selectedProperties, selectedProduct });

                    return (
                        <div
                            style={{
                                display: "flex",
                                alignItems: "space-between",
                                justifyContent: "space-between",
                                width: "100%",
                                gap: 10,
                            }}
                        >
                            {imageSrc ? (
                                <div>
                                    <div className={classnames(styles["image-property-selector-dropdown"], disabled && styles["image-property-disabled"])} style={{ backgroundColor: hexColor }}>
                                        <CustomImageNew
                                            src={imageSrc}
                                            fill
                                            style={{
                                                objectFit: getBrandProductImageObjectFit(appProps),
                                                width: "100%",
                                                height: "100%",
                                            }}
                                            alt={propertyValue?.value}
                                        />
                                    </div>
                                </div>
                            ) : hexColor ? (
                                <div
                                    className={classnames(styles["color-property-inner"], disabled && styles["color-property-disabled"], isColorLight && styles["color-property-inner-light"])}
                                    style={{ backgroundColor: hexColor }}
                                />
                            ) : null}
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    width: "100%",
                                    gap: 20,
                                }}
                            >
                                <div>
                                    {propertyName && <div>{propertyName}</div>}
                                    {text && (
                                        <div style={{ fontSize: "13px" }} className={propertyName && "secondary-color"}>
                                            {text}
                                        </div>
                                    )}
                                </div>

                                <div>
                                    {isCurrentVariant && (
                                        <div style={{ fontSize: "13px" }} className={"secondary-color"}>
                                            {getLocaleText("returning")}
                                        </div>
                                    )}
                                    {disabled && <div style={{ fontSize: "11px" }}>{appProps?.getLocaleText("out-of-stock")}</div>}
                                </div>
                            </div>
                        </div>
                    );
                }}
                onChange={(propertyValue) => {
                    onSelectedPropertyValue({ propertyValue, deSelectEnabled: true });
                }}
            />
            <PropertyDescription {...props} showName={false} showLine={false} />
        </>
    );
}
